import { View } from './view';

export const ButtonsWrapper = View;
